import { publicRuntimeConfig } from '../_cactus_core/config/runtime';

export const useTitleFromBackoffice = true;

let appName = '';

try {
  appName = process.env.APP_NAME || publicRuntimeConfig().appName || '';
} catch (error) {
  appName = process.env.APP_NAME || '';
}

export const metaTitle = `${appName} 🍀 Cassino e Apostas Online | Apostas Esportivas`;

export const useDescriptionFromBackoffice = true;

export const metaDescription = `${appName} é o melhor site de cassino 🎰 e apostas esportivas ⚽ com diversas opções de esportes para apostar, jogos de cassino para jogar e promoções exclusivas 🎁. Com uma plataforma intuitiva e segura, oferecemos milhares de jogos de cassino, jogos de esportes e suporte ao cliente 24/7.`;
